module.exports = __webpack_public_path__ + "img/water.205ad683.png";